import { gql, TypedDocumentNode } from '@apollo/client';
import { PaymentSource } from '../../../constants';

export type BillingAddress = {
  __typename: 'RestBillingAddress';
  countryCode: string;
  extendedAddress: string | null;
  id: string | null;
  locality: string;
  postalCode: string;
  region: string;
  streetAddress: string;
};

export type PaymentMethodAttributes = {
  __typename: 'RestPaymentMethodAttributes';
  cardType?: string;
  cardholderName?: string;
  cardNumber?: string;
  expirationDate: string;
  isValid?: boolean;
  lastFour: string;
  source: PaymentSource;
  billingAddress: BillingAddress | null;
};

export type PaymentMethod = {
  __typename: 'RestPaymentMethod';
  id: string;
  attributes: PaymentMethodAttributes;
};

export type PaymentMethodsQuery = {
  paymentMethods: {
    __typename: 'RestPaymentMethods';
    data: PaymentMethod[];
  };
};

export const PAYMENT_METHOD_ATTRIBUTES_FRAGMENT = gql`
  fragment PaymentMethodAttributesFragment on RestPaymentMethodAttributes {
    cardType: card_type
    cardholderName: cardholder_name
    expirationDate: expiration_date
    isValid: is_valid_card
    lastFour: last_four
    source
    billingAddress: billing_address @type(name: "RestBillingAddress") {
      countryCode: country_code_alpha2
      extendedAddress: extended_address
      id
      locality
      postalCode: postal_code
      region
      streetAddress: street_address
    }
  }
`;

export const PAYMENT_METHOD_FRAGMENT = gql`
  fragment PaymentMethodFragment on RestPaymentMethod {
    id
    attributes @type(name: "RestPaymentMethodAttributes") {
      ...PaymentMethodAttributesFragment
    }
  }
  ${PAYMENT_METHOD_ATTRIBUTES_FRAGMENT}
`;

export const PAYMENT_METHODS_QUERY: TypedDocumentNode<PaymentMethodsQuery, void> = gql`
  query PaymentMethodsQuery {
    paymentMethods @rest(type: "RestPaymentMethods", endpoint: "moda", path: "/v3.5/payments") {
      data @type(name: "RestPaymentMethod") {
        ...PaymentMethodFragment
      }
    }
  }
  ${PAYMENT_METHOD_FRAGMENT}
`;
